import styled from 'styled-components';

export const Container = styled.span<{ $loading?: boolean }>`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
